(function () {
    "use strict";

    angular
        .module("rms.common")
        .directive("rmsDatatableToggleManager", rmsDatatableToggleManager);

    function rmsDatatableToggleManager(lodash, $document, $timeout) {
        return {
            restrict: "E",
            require: ["ngModel"],
            scope: {
                options: "=",
                refresh: "=?",
                readonly: "=?",
                hasError: "=?",
                errorMessage: "=?"
            },
            controller: rmsDatatableToggleManagerCtrl,
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "common/app/components/datatable-toggle-manager",
            link: {
                post: function (scope, elem, attr, ctrl) {
                    var vm = scope.vm;
                    vm.ngModelCtrl = ctrl[0];

                    vm.ngModelCtrl.$render = function () {
                        console.log('hi');
                        var modelValue = vm.ngModelCtrl.$viewValue;
                        //
                        if (modelValue && modelValue.length > 0) {
                            // get required columns
                            var requiredColumns = vm.y.filter(function (column) {
                                return column.required;
                            });

                            // get all selected & required columns values

                            var selectedColumnValues = getColumnsByValue(modelValue);
                            var requiredColumnValues = requiredColumns.map(function (requiredColumn) {
                                return requiredColumn.value.toString();
                            });

                            // determine missing columns by difference.
                            var differenceColumns = lodash.difference(requiredColumnValues, selectedColumnValues);

                            // for each missing column create a new Y object and append to model value
                            vm.selected = modelValue.map(function (row) {
                                differenceColumns.forEach(function (difference) {
                                    row.y.push(new vm.Y(lodash.find(requiredColumns, {'value': parseInt(difference)})))
                                });

                                return row;
                            });

                            // generate new selected columns by selected rows
                            var newSelectedColumns = getColumnsByValue(vm.selected);

                            // determine selected columns by filtering all columns with selected columns
                            vm.columns = vm.y.filter(function (item) {
                                return newSelectedColumns.includes(item.value.toString());
                            });

                            vm.x = vm.x.filter(function ($x) {
                                return !lodash.find(vm.selected, {'value': $x.value});
                            });

                            vm.originalColumns = vm.columns.slice();
                            vm.originalSelected = lodash.cloneDeep(vm.selected);
                        } else {
                            vm.init();
                        }
                    };

                    function getColumnsByValue(model) {
                        // take all y values and flatten. then group by their value
                        return Object.keys(lodash.groupBy(lodash.flatten(model.map(function (value) {
                            return value.y;
                        }, [])), 'value'));
                    }
                }
            }
        };

        function rmsDatatableToggleManagerCtrl($scope, lodash, GenericModel) {
            var vm = this;
            this.$onInit = function() {
                var options = vm.options.options;

                vm.x = options.x;
                vm.y = options.y;
                vm.keyX = options.key_x;
                vm.keyY = options.key_y;
                vm.legend = options.legend;
                vm.currentY = null;
                vm.currentX = null;
                vm.originalColumns = [];
                vm.originalSelected = [];

                // vm.filteredX = [];

                vm.columns = [];
                vm.selected = [];

                vm.addX = addX;
                vm.removeX = removeX;
                vm.updateY = updateY;
                vm.getYIndex = getYIndex;
                vm.resetTable = resetTable;
                vm.Y = Y;

                vm.init = init;
            }

            function init() {
                var required = vm.y.filter(function (column) {
                    return column.required;
                });

                $timeout(function () {
                    required.forEach(function (required_col) {
                        vm.columns.push(required_col);
                    });
                    vm.originalColumns = vm.columns.slice();
                })
            }

            function updateNgModel(value) {
                vm.ngModelCtrl.$setViewValue(value);
            }

            function addX() {
                if (vm.currentX !== null) {
                    var isDupe = vm.selected.some(function (selection) {
                        return selection.value === vm.currentX.value;
                    });

                    if (isDupe) {
                        return;
                    }

                    $timeout(function () {
                        $scope.$apply(function () {
                            var columns = vm.columns.map(function (column) {
                                return new Y(column);
                            });

                            vm.selected.unshift(Object.assign({y: columns}, vm.currentX));
                            vm.x = vm.x.filter(function (item) {
                                if (typeof item !== "undefined") {
                                    return item.value !== vm.currentX.value;
                                }
                            });
                        });
                        updateNgModel(vm.selected);
                    })
                }
            }

            function removeX(value) {
                $timeout(function () {
                    $scope.$apply(function () {
                        vm.selected = vm.selected.filter(function (selection) {
                            return selection.value !== value;
                        });

                        var currentXOptions = vm.x.slice();
                        currentXOptions.unshift(lodash.find(vm.options.x, {value: value}));
                        vm.x= currentXOptions;
                    });

                    updateNgModel(vm.selected);
                })
            }

            function updateY() {
                $timeout(function () {
                    $scope.$apply(function () {
                        vm.selected = vm.selected.map(function (selection) {
                            var copy = Object.assign({}, selection);
                            var existingY = copy.y.slice();

                            copy.y = vm.columns.reduce(function (carry, column) {
                                var index = existingY.findIndex(function (element) {
                                    if (element === null) return false;
                                    return element.value === column.value
                                });

                                index === -1
                                    ? carry.push(new Y(column))
                                    : carry.push(existingY[index]);

                                return carry;
                            }, []);

                            return copy;
                        });
                        updateNgModel(vm.selected);
                    })
                })
            }

            function getYIndex(selected_x, column) {
                return lodash.findIndex(selected_x.y, function (_y) {
                    return _y.value === column.value
                });
            }

            function resetTable() {
                $timeout(function () {
                    $scope.$apply(function () {
                        vm.columns = vm.originalColumns.slice();
                        vm.selected = lodash.cloneDeep(vm.originalSelected);
                        updateNgModel(vm.selected);
                    })
                })
            }

            function Y(data) {
                this.value = data.value;
                this.choice = 'nil'
            }

            function ModelValue(selection, requiredY) {
                this.selection = selection;
                this.required_y = requiredY
            }
        }
    }
})();
